<template>
  <div>
    <eden-table-actions :title="title" @search="search">
      <template slot="actions">
        <VoucherFilter
          :disabled="loading"
          :clear="filterParams.clear"
          @filter="filter"
          class="mr-2"
        />
        <el-button type="primary" @click="command({ action: 'add' })"
          >Create Voucher</el-button
        >
      </template>
    </eden-table-actions>
    <eden-loader v-if="loading" />
    <template v-else>
      <eden-filter-items
        class="ml-auto"
        v-if="filterParams.status"
        :params="filterParams.paramsLabel"
        @clear-filter="clearFilter"
        @clear-filters="clearFilters"
      />
      <!-- <pre>{{ pageData }}</pre> -->
      <template v-if="pageData.length">
        <el-table :data="pageData" empty-text="No Vouchers">
          <el-table-column width="220">
            <template slot="header">
              <span>Code</span>
            </template>
            <template slot-scope="scope">
              <span
                @click="
                  command({
                    action: 'detail',
                    id: scope.row.uuid,
                    index: scope.$index,
                  })
                "
                class="font-sm text-primary cursor-pointer"
              >
                {{ scope.row.code }}
              </span>
            </template>
          </el-table-column>
          <el-table-column width="100">
            <template slot="header">
              <span>Value</span>
            </template>
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.value_type === "fixed"
                    ? formatPrice(scope.row.value)
                    : formatPercentage(scope.row.value)
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column width="150">
            <template slot="header">
              <div class="table--header">
                <span>Applicable Point</span>
              </div>
            </template>
            <template slot-scope="scope">
              {{
                scope.row.redemption_type === "specific_stores"
                  ? "Specific Store"
                  : scope.row.redemption_type === "specific_categories"
                  ? "Specific Category"
                  : "All Stores"
              }}
            </template>
          </el-table-column>
          <el-table-column width="150">
            <template slot="header">
              <div class="table--header">
                <span>Usage Limit</span>
              </div>
            </template>
            <template slot-scope="scope">
              {{ scope.row.usage_limit || "Unlimited" }}
            </template>
          </el-table-column>
          <el-table-column>
            <template slot="header">
              <span>Customer Type</span>
            </template>
            <template slot-scope="scope">
              {{
                scope.row.customer_type === "return_customers"
                  ? "Return Customers"
                  : scope.row.customer_type === "first_time_customers"
                  ? "First Time Customers"
                  : "All Users"
              }}
            </template>
          </el-table-column>
          <el-table-column>
            <template slot="header">
              <span>Start Date</span>
            </template>
            <template slot-scope="scope">
              <span class="font-sm">
                {{ formatDate(scope.row.start_date) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot="header">
              <span>Expiry Date</span>
            </template>
            <template slot-scope="scope">
              <span class="font-sm">
                {{ formatDate(scope.row.expiry_date, "do m, y") }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="
              allowAccessFor([
                'superadmin',
                'admin',
                'vendor_manager',
                'operations',
              ])
            "
            min-width="60"
          >
            <template slot-scope="scope">
              <el-dropdown @command="command" class="more">
                <span class="el-dropdown-link">
                  <i class="eden-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :command="{
                      action: 'edit',
                      id: scope.row.uuid,
                      item: scope.row,
                      index: scope.$index,
                    }"
                    >Edit Voucher</el-dropdown-item
                  >
                  <el-dropdown-item
                    :command="{
                      action: 'view',
                      id: scope.row.uuid,
                      index: scope.$index,
                    }"
                    >View Voucher Details</el-dropdown-item
                  >
                  <el-dropdown-item
                    :command="{
                      action: 'delete',
                      id: scope.row.uuid,
                      index: scope.$index,
                    }"
                    class="text-danger"
                    >Delete Voucher</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <eden-pagination
          v-if="pageData.length"
          :from="pagination.from"
          :to="pagination.to"
          :total="pagination.total"
          :current-page.sync="page"
          :page-size="pagination.per_page"
        />
      </template>
      <eden-content-empty v-else :text="'No Vouchers'" />
    </template>
    <VoucherForm
      :action="voucher.action"
      :show.sync="voucher.visibility"
      :voucher="singleVoucher"
      @success="getVouchers"
    />
    <VoucherDelete
      :show.sync="showDeleteVoucher"
      :voucher-id="voucherId"
      @success="getVouchers"
    />
    <VoucherDetail
      :show.sync="showVoucherDetail"
      :voucher="voucherDetail"
      :loading="isLoading"
      @edit-voucher="command({ action: 'edit', item: voucherDetail })"
      @delete-voucher="command({ action: 'delete', id: voucherDetail.uuid })"
    />
  </div>
</template>

<script>
import VoucherDelete from "./VoucherDelete.vue";
import VoucherDetail from "./VoucherDetail.vue";
import VoucherFilter from "./VoucherFilter.vue";
import VoucherForm from "./VoucherForm.vue";
import voucher from "@/requests/vouchers/voucher";

export default {
  components: { VoucherForm, VoucherDelete, VoucherDetail, VoucherFilter },
  data() {
    return {
      loading: false,
      isLoading: false,
      searchQuery: "",
      pageData: [],
      voucher: {
        action: "add",
        visibility: false,
        data: {},
      },
      filterParams: {
        clear: false,
        status: false,
        params: {},
        paramsLabel: {},
      },
      voucherId: "",
      showDeleteVoucher: false,
      pagination: [],
      page: 1,
      singleVoucher: {},
      voucherDetail: {},
      showVoucherDetail: false,
    };
  },
  computed: {
    title() {
      return this.pageData?.length + " Vouchers";
    },
  },
  created() {
    this.getVouchers();
  },
  methods: {
    command(command) {
      this.voucherId = command.id;
      this.singleVoucher = command.item;
      switch (command.action) {
        case "add":
          this.voucher.action = "add";
          this.voucher.visibility = true;
          break;
        case "edit":
          this.voucher.action = "edit";
          this.voucher.visibility = true;
          break;
        case "delete":
          this.voucher.action = "delete";
          this.showDeleteVoucher = true;
          break;
        case "detail":
          this.voucher.action = "detail";
          this.getVoucher();
          this.showVoucherDetail = true;
          break;
        case "view":
          this.voucher.action = "view";
          this.$router.push({
            name: "vouchers.details",
            params: { id: this.voucherId },
          });
          break;
      }
    },
    async getVoucher() {
      try {
        this.isLoading = true;
        const response = await voucher.voucher(this.voucherId);
        if (response.data.status) {
          this.voucherDetail = response.data.data;
        }
      } catch (err) {
        this.$message.error(err.response.data.message);
      } finally {
        this.isLoading = false;
      }
    },
    async getVouchers() {
      this.loading = true;
      const params = {
        code: this.searchQuery,
        customer_type: this.filterParams.params?.customer_type,
        redemption_type: this.filterParams.params?.redemption_type,
        min_start_date: this.filterParams.params?.min_start_date,
        max_start_date: this.filterParams.params?.max_start_date,
        min_expiry_date: this.filterParams.params?.min_expiry_date,
        max_expiry_date: this.filterParams.params?.max_expiry_date,
      };
      await voucher
        .list(params)
        .then((response) => {
          if (response.data.status) {
            this.pageData = response.data.data;
            this.pagination = response.data.meta;
          }
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    filter({ params, paramsLabel }) {
      this.loading = true;
      this.filterParams = {
        status: true,
        params: params,
        paramsLabel: paramsLabel,
      };
      this.page = 1;
      this.getVouchers();
    },
    clearFilter(key) {
      delete this.filterParams.params[key];
      delete this.filterParams.paramsLabel[key];

      const keys = this.filterParams.params;

      if (Object.keys(keys).length) {
        this.filter({
          params: this.filterParams.params,
          paramsLabel: this.filterParams.paramsLabel,
        });
      } else {
        this.clearFilters();
      }
    },
    clearFilters() {
      this.filterParams = {
        clear: true,
        status: false,
        params: {},
        paramsLabel: {},
      };
      this.getVouchers();
    },
    search(query) {
      this.searchQuery = query;
      this.page = 1;
      this.getVouchers();
    },
  },
};
</script>
